export const uniq = <T>(array: T[]) => Array.from(new Set(array))
